export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9398.ebc64bb8.jpg";